/* eslint-disable react/jsx-no-undef */
import { queryUserList } from '@api/roleManagement';
import { ZeissInput } from '@components/input';
import ZeissRangePicker from '@components/rangePicker';
import ZeissSelect from '@components/select';
import { DIC_FIELD_NAMES, ROLE_KEYS_MAP } from '@constants';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { sectorMap } from '@views/pages/AnnouncementList/tool';
import { Cascader, Col, Form, Row } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './index.scss';
import { useSectorMark } from '@hooks/useSectorMarkHook';
import { useRecoilState } from 'recoil';
import { userInfo } from '@store';
import { projectStatusMap } from '@components/ProjectFromComponents/data';
import { dealerSectorArr } from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';

const overdueBooleanArr = [
  {
    label: '是',
    value: '1'
  },
  {
    label: '否',
    value: '0'
  }
];

const lerBooleanArr = [
  {
    label: '是',
    value: '0'
  },
  {
    label: '否',
    value: '1'
  }
];

interface SearchFormPropsInterface {
  onFieldsChange?: () => void;
  activeTab: string;
  dicList: any;
  systemCity: SystemCityItemInterface[];
}

const ProjectSearchForm = (props: SearchFormPropsInterface, ref: any) => {
  const { dicList, systemCity, onFieldsChange, activeTab } = props;
  const [form] = Form.useForm();
  const { sector, productLine: productLineList } = dicList;
  // const { sector, productLine: productLineList, subjectMatterBrand } = dicList;
  const [customerCompanyTypeOptions, setCustomerCompanyTypeOptions] = useState(
    []
  );
  const [userInfos] = useRecoilState(userInfo);
  const sectorMark = useSectorMark();
  const showDealerName =
    userInfos.roleKeys === ROLE_KEYS_MAP.admin ||
    (userInfos.roleKeys === ROLE_KEYS_MAP.sales &&
      userInfos.userTypesId
        ?.split(',')
        .some((sectorId: string) => dealerSectorArr.includes(sectorId)));
  const [, setUserList] = useState<any>([]);
  const getQueryUserList = async () => {
    const res = await queryUserList({
      pageNumber: 1,
      pageSize: 9999
    });
    setUserList(res?.users?.records ?? []);
  };

  useEffect(() => {
    getQueryUserList();
  }, []);

  const handeChange = () => {
    onFieldsChange?.();
  };

  // 校验表单内容并且返回数据
  const submitClick = () => {
    return form.validateFields();
  };

  const getSectorRelatedOption = (data: any) => {
    const sectorDictItem = dicList.sectorDict?.[sectorMap[data]];
    return sectorDictItem || {};
  };

  // 下拉
  const renderSelectOptions = (sectorOptionsItem: any) => {
    const { customerCompanyType } = sectorOptionsItem;
    return customerCompanyType;
  };

  const onSectorChange = (data: any) => {
    const sectorOptionsItem = getSectorRelatedOption(data);
    const customerCompanyTypeList = renderSelectOptions(sectorOptionsItem);
    setCustomerCompanyTypeOptions(customerCompanyTypeList);
    form.setFieldsValue({
      customerCompanyType: []
    });
  };

  useImperativeHandle(ref, () => ({
    submitClick,
    resetFields: form.resetFields
  }));

  return (
    <Form form={form} className="contentListForm" onFieldsChange={handeChange}>
      <Row gutter={[24, 0]}>
        {/* {userInfos.roleKeys !== ROLE_KEYS_MAP.sales && ( */}
        <Col span={6}>
          <Form.Item label={sectorMark} name="sectorType">
            <ZeissSelect
              maxTagCount="responsive"
              allowClear
              placeholder="请选择"
              options={sector}
              fieldNames={DIC_FIELD_NAMES}
              onChange={onSectorChange}
            />
          </Form.Item>
        </Col>
        {/* )} */}
        <Col span={6}>
          <Form.Item label="省市" name="provinceAndCity">
            <Cascader
              options={systemCity}
              placeholder={`请选择省市`}
              className="pc-cascader-layout"
              multiple
              maxTagCount="responsive"
              changeOnSelect
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="发布时间" name="publishTime">
            <ZeissRangePicker
              format="YYYY-MM-DD"
              allowClear
              placeholder={['开始', '结束']}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="开标时间" name="openTime">
            <ZeissRangePicker
              format="YYYY-MM-DD"
              allowClear
              placeholder={['开始', '结束']}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="客户单位" name="customerCompany">
            <ZeissInput allowClear placeholder="请输入客户单位" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="客户单位类型" name="customerCompanyType">
            <ZeissSelect
              mode="multiple"
              maxTagCount="responsive"
              placeholder="请选择"
              options={customerCompanyTypeOptions}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="产品分类" name="productLineKey">
            <ZeissSelect
              mode="multiple"
              maxTagCount="responsive"
              placeholder="请选择"
              options={productLineList}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
        {/* <Col span={6}>
          <Form.Item label="标的物品牌" name="manufacturer">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              placeholder="请选择"
              options={subjectMatterBrand}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col> */}

        {/* <Col span={6}>
          <Form.Item label="当前处理人" name="queryCurrentUserId">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={userList}
              allowClear
              fieldNames={{ label: 'realName', value: 'userId' }}
            />
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item label="当前处理人" name="queryCurrentProcessorUserName">
            <ZeissInput placeholder="请选择" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="项目ID" name="noticeCode">
            <ZeissInput allowClear placeholder="请输入项目ID" />
          </Form.Item>
        </Col>
        {showDealerName ? (
          <Col span={6}>
            <Form.Item label="经销商" name="dealerName">
              <ZeissInput placeholder="请输入" allowClear />
            </Form.Item>
          </Col>
        ) : null}

        {activeTab !== projectStatusMap.endTender &&
        activeTab !== projectStatusMap.deleted ? (
          <Col span={6}>
            <Form.Item label="是否逾期" name="overdue">
              <ZeissSelect
                maxTagCount="responsive"
                maxTagTextLength={7}
                placeholder="请选择"
                options={overdueBooleanArr}
                allowClear
              />
            </Form.Item>
          </Col>
        ) : null}

        <Col span={6}>
          <Form.Item label="LER" name="lerStatus">
            <ZeissSelect
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={lerBooleanArr}
              allowClear
            />
          </Form.Item>
        </Col>

        {/* <Col span={6}>
          <Form.Item label="项目状态" name="projectStatus">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={projectStatusList}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col> */}
      </Row>
    </Form>
  );
};
export default forwardRef(ProjectSearchForm);
